import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the client FAQ page dispatches for the saga to act
 * on. Kept out of the slice's reducers: they trigger side effects, not state
 * transitions.
 */

/** Load the published FAQ and the licence's CSM (dispatched on mount). */
export const clientFaqRequested = createAction('clientFaq/requested');

/** Mail the licence's CSM (#695), from "Still need help?" or a search without result. */
export const csmMessageSubmitted = createAction<{ message: string }>(
  'clientFaq/csmMessageSubmitted',
);

/** A search found nothing (#735): reported for the admin, silently. */
export const searchMissed = createAction<{ query: string }>('clientFaq/searchMissed');
